import PropTypes from 'prop-types';

export const selectOptions = PropTypes.arrayOf(
  PropTypes.shape({
    value: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  })
);
